import { Typography } from '@mui/material';
import { Layout } from '@rumblefish/ui/Rumblefish23Theme';
import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { ContactXRPL } from './Contact';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { StyledContainer, StyledTypographySmall } from './styles';
import { WhyRF } from './WhyRF';
import { WhyXRPLedger } from './WhyXRPLedger';
import { xrplBlockchainDevelopmentSeo } from './xrplBlockchainDevelopmentPage.seo';
import type { XRPLBlockchainDevelopmentPageProps } from './xrplBlockchainDevelopmentPage.types';
import { XRPLBlockchainDevelopmentServices } from './xrplBlockchainDevelopmentServices/xrplBlockchainDevelopmentServices';
import { XRPLDevelopmentProcess } from './XRPLevelopmentProcess';
import { OurWork } from './OurWork';

export const XRPLBlockchainDevelopmentPage = ({
  blogPosts,
  caseStudies,
}: XRPLBlockchainDevelopmentPageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...xrplBlockchainDevelopmentSeo} />
      <Hero />
      <XRPLBlockchainDevelopmentServices />
      <WhyXRPLedger />
      <WhyRF />
      <XRPLDevelopmentProcess />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <ContactXRPL />
      <StyledContainer>
        <StyledTypographySmall>
          <Typography component="span" sx={{ fontWeight: '600' }}>
            Rumble Fish
          </Typography>
          <Typography component="span">
            &nbsp;- XRPL expertise at your service
          </Typography>
        </StyledTypographySmall>
      </StyledContainer>
    </Layout>
  );
};
